import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import PharmaorderInfo from '../PharmaorderInfo';
import ProductListByOrderId from './vieworder/ProductListByOrderId';
import { convertToRS, transformDateValue } from 'core/js/FormUtils';
import IconEnabled from '../../../core/components/layout/IconEnabled';


export default function PharmaorderListTableRow({obj, getActionComponent,actionList, handleRowClick}){
  const {mobileView} = useSelector((state) => state.menu);
  const {myBusinessUserList} = useSelector((state) => state.headerslice);
  const {rolename, username, userid} = useSelector((state) => state.headerslice.userprofileInfo);

  useEffect(()=>{
  },[])
  const getUserName = (executivename) => {
    // If not an email, return as is
    if (!executivename || !executivename.includes('@')) return executivename;
    
    // If email, find user in myBusinessUserList by email
    const user = myBusinessUserList.find(user => user.email === executivename);
    return user ? user.username : executivename;
  }
  const getUserNameByCreator = (createdby) => {
    const user = myBusinessUserList.find(user => user.userid === createdby);
    return user ? user.username : '-';
  }
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'secondary.lighter', color: 'primary.main'
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.orderid}</Typography></Grid>
              <Grid item lg={3} xs={4} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.partyname}</Typography></Grid>
              {!mobileView?<>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{getUserNameByCreator(obj.createdby)}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{convertToRS(obj.ordervalue)}</Typography></Grid>
              

              </>:<></>}
              
              {/* <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.dispatchdate}</Typography></Grid> */}
              <Grid item lg={2} xs={4} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.orderstatus}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{transformDateValue(obj.creationTimestamp)  }</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{transformDateValue(obj.submitdate)}</Typography></Grid>

              <Grid item lg={2} xs={2} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {/* {getActionComponent(obj)} */}
                  {
                    (
                      (obj.orderstatus==='DRAFT' || obj.orderstatus==='REFERRED BACK') && userid===obj.createdby
                    ) &&
                    <IconEnabled key={`${obj.id}-${actionList[2].title}`} actionObj={actionList[2]} id={obj.id} />
                  }
                  {
                    (rolename==='PHARMA_OMS_ADMIN' || rolename==='PHARMA_OMS_MANAGER') &&
                    <IconEnabled key={`${obj.id}-${actionList[2].title}`} actionObj={actionList[2]} id={obj.id} />
                  }
                
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        {obj.expand ?
          <Grid container direction="row">
            <Grid item sx={{ width: '100%' }}>
              {/* < PharmaorderInfo  pharmaorderObj={obj} /> */}
              <ProductListByOrderId orderid={obj.orderid}/>
            </Grid>
          </Grid>
          : <Grid container direction="row">
            <Grid item sx={{ width: '100%' }}>
              <Divider />
            </Grid>
          </Grid>
        
        }
      </>
      
    )
}